import { Injectable } from '@angular/core';
import { Slide } from '../_models/index';

@Injectable()
export class SliderService {
    slides: Array<Slide>;

    constructor() {
        this.slides = [
            { link: "https://www.erisinfo.com/updates/introducing-mexico-package/", image: "/assets/images/slider1.png" },
            { link: "https://www.erisinfo.com/ca_xplorer/", image: "/assets/images/slider2.png" },
            { link: "https://www.erisinfo.com/updates/now-available-physical-setting-report/", image: "/assets/images/slider4.png" },
            { link: "https://www.erisinfo.com/erisdirect/", image: "/assets/images/slider3.png" }
        ]
    }

    getSlide() {
        let i = this.getRandomInt(this.slides.length);
        return this.slides[i];
    }

    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }

}